export default __webpack_public_path__ + "static/media/close-new.6e5b57fc.svg";